export default "__VITE_ASSET__BVZAzIYi__"